
import {
  GET_TIME_SLOTS_URL,
  UPDATE_TIME_SLOT_STATUS_URL,
  GET_CONFLICTING_TIME_SLOTS_URL,
  SEND_EXPIRED_SLOTS_SUPPORT_EMAIL_URL,
} from "services/url.service";
import { commonTransform } from "../handleTransformation";
import { tags } from "../constants";

export const timeSlotMutations = {
  updateTimeSlotStatus: {
    getUrl: ({timeSlotId, status}) => UPDATE_TIME_SLOT_STATUS_URL(timeSlotId, status),
    transformResponse: (res) => commonTransform(res),
    method: "PUT",
    invalidatesTags: [tags.EMPLOYEES, tags?.TIME_SLOTS, tags?.HIRING_MANAGER_DASHBOARD],
  },
  sendExpiredSlotsSupportEmail: {
    getUrl: () => SEND_EXPIRED_SLOTS_SUPPORT_EMAIL_URL(),
    transformResponse: (res) => commonTransform(res),
    method: "POST",
  },
};

export const timeSlotQueries = {
  getTimeSlots: {
    getUrl: ({companyId, touchPointInstanceId}) => { return GET_TIME_SLOTS_URL(companyId, touchPointInstanceId)},
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [tags.TIME_SLOTS],
  },
  getConflictingTimeSlots: {
    getUrl: ({ userId, hash }) => GET_CONFLICTING_TIME_SLOTS_URL(userId, hash),
    transformResponse: (res) => commonTransform(res),
    method: "GET",
    providesTags: [tags.TIME_SLOTS],
  },
};
